/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { GeneralRestApiOptions } from './types';

export const createGeneralProductSubscriptionsRepository = (
    options: GeneralRestApiOptions
): Types.GeneralProductSubscriptionsRepository => ({
    async add(params, requestOptions) {
        return options.request('/productSubscriptions/add', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async addTokenizationFees(params, requestOptions) {
        return options.request('/productSubscriptions/addTokenizationFees', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
